import type { FooterProps } from './types'

import './index.scss'

const mainClass = 'footer'

export const Footer = ({ copyright }: FooterProps) => {
  if (!copyright) {
    return null
  }

  return (
    <>
      <hr className={`${mainClass}__separator`} />
      <footer className={mainClass} role="contentinfo">
        <p className={`${mainClass}__copyright`}>{copyright}</p>
      </footer>
    </>
  )
}
